export default __webpack_public_path__ + "static/media/DetectiveBlack.9e035e80.png";